import { FC, Fragment } from 'react'
import DataRow from './DataRow'
import { useTranslation } from 'react-i18next'
interface IDynamisServiceCard {
  options: any[],
  data: any,
  setData: Function,
  fieldName: string,
  decisionId: number | null,
  setDecisionId: Function,
}

const DynamisServiceCard: FC<IDynamisServiceCard> = ({ decisionId, setDecisionId, options, data, setData, fieldName }) => {

  const { t } = useTranslation()

  const handleChange = (data: any[], key: string) => {
    setData((prev: any) => ({ ...prev, [key]: [...data] }))
  }

  const handleAddRow = () => {
    setData((prev: any) => ({ ...prev, [fieldName]: [...prev[fieldName], { hospitalMedicalServiceId: null, notes: "" }] }))
  }

  return (
    <div>
      <div className='alert'>{t(`add-${fieldName}`)}</div>
      {
        //@ts-ignore
        data[fieldName].map((item: any, index: number) => (
          <Fragment key={index}>
            <DataRow
              decisionId={decisionId}
              setDecisionId={setDecisionId}
              setData={(data: any) => handleChange(data, fieldName)} data={data[fieldName]} options={options} index={index} onDelete={(data: any) => handleChange(data, fieldName)} />
          </Fragment>
        ))
      }
      <div className='alert pointer' onClick={handleAddRow}>
        {t("add-another")}  +
      </div>
    </div>
  )
}

export default DynamisServiceCard